import Create from './create/CreateMusicProductDigital';
import Edit from './edit/EditMusicProductDigital';
import Individual from './individual/MusicProductDigital';
import List from './list/MusicProductsDigital';

export default { Individual, List, Edit, Create };
